import { SdkContext } from '../internal'
import type { LinkEmbed } from '@/lib/embeds'

/** F-92: link embeds (player or preview card) for the composer's paste preview. */
export class EmbedsResource {
  constructor(private ctx: SdkContext) {}

  /** Resolves one link. 422 (`param: url`) when it has no preview; 429 when called too often. */
  async resolve(url: string): Promise<LinkEmbed> {
    return this.ctx.call({ httpMethod: 'POST', path: '/embeds/resolve', hasBody: true }, { body: { url } })
  }
}
